import {TimeSeriesController} from '../timeSeriesController';

export class TechnicalAnalysisChartController extends TimeSeriesController {
  constructor(widget, updateCallback, togglePreloader) {
    super(widget, updateCallback);
    this.togglePreloader = togglePreloader;
    this.togglePreloader(true);
  }

  loadHistoricData(snapshotData) {
    this.togglePreloader(false);
    const data = this.processingSnapshotData(snapshotData);
    this.updateCallback(data);
  }


  update(updatingDatasetId) {
    // TA chart doesn't support real-time update
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/technical-analysis-chart/controller.js